import React from "react";
import HeroThree from "./HeroThree";
import HisJourney from "./HisJourney";
import KeyProjects from "../about-enterpreneur/KeyProjects";
import SpeakerInvitation from "./SpeakerInvitation";
import Audience from "./Audience";
import BookEvent from "./BookEvent";
import Testimonials from "../home/testimonials/Testimonials";

const Motivational = () => {
  return (
    <>
      <HeroThree />
      <HisJourney />
      <KeyProjects />
      <SpeakerInvitation />
      <Testimonials
        badge="Testimonials"
        title="Real Words. Real Impact."
        description="Hear from those who’ve seen, felt, and grown from Deepak Sharma’s journey."
      />
      <Audience />
      <BookEvent />
    </>
  );
};

export default Motivational;
